$(document).ready(function() {

  if ($("#eventCreate").length) {
    $("#eventAreaId").change(function() {

      // Clear Templates
      $("#eventTemplateId").html("");
        $.getJSON("/app/areas/getTemplates?area_id=" + $(this).val(), function(data) {

        var newHTML = '';
        $.each(data, function(key, template) {
          newHTML += '<option value="' + template.id + '">' + template.name + '</option>';
        });

        $("#eventTemplateId").html(newHTML);

      });


    });

  }

});
